module.exports = __webpack_public_path__ + "img/banner_6.3f2f4891.png";